var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.79406e-06 9.50003C-1.79812e-06 9.84055 0.13205 10.181 0.395599 10.4406L8.69309 18.6102C9.22091 19.1299 10.0767 19.1299 10.6043 18.6102C11.1319 18.0907 11.1319 17.2483 10.6043 16.7286L3.26222 9.50003L10.604 2.27143C11.1316 1.75174 11.1316 0.909399 10.604 0.389957C10.0764 -0.129986 9.22065 -0.129986 8.69283 0.389957L0.395343 8.55942C0.131751 8.81916 -1.79e-06 9.15964 -1.79406e-06 9.50003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.e30677f6f7f25765747b9af31b2ee5c0.svg";
export { ForwardRef as ReactComponent };